export default "__VITE_ASSET__a3b14707__"